(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-buy-now]');
    if (!button) return;
    event.preventDefault();
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    var form = button.closest('form');
    if (!form) return;

    var routes = (window.FoxTheme && window.FoxTheme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add';
    var root = routes.root_url || '/';
    if (root.charAt(root.length - 1) !== '/') root += '/';

    button.classList.add('btn--loading');
    button.setAttribute('aria-disabled', 'true');

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add_failed');
        window.location.href = root + 'checkout';
      })
      .catch(function () {
        button.classList.remove('btn--loading');
        button.removeAttribute('aria-disabled');
      });
  });
  } catch(e) { console.error(e); }
})();

})();
